const taskCompatibility =[
    //d and d  
    {
        head:`Least compatible`,
        body:`Two fiery types coming together works fairly well
        socially, although when it comes to tasks, a Dominant style's competitive nature and need for constant control may step on the other and overwhelm the counterpart`,
    },
    //i and i
    {
        head:`Least compatible`,
        body:`This talkative pair is statistically the most
        socially compatible and therefore are also likely to be the least productive as far
        as working together on tasks. This is because neither is motivated to
        deal with the little steps and details, typically seeing things generally as the bigger picture`,
    },
    //s and s
    {
        head:`Moderately compatible`,
        body:`There may be a fog of awkwardness first but once they’ve hashed out who is dependent on what,
        the two Steady types can see clearly where they're headed, bringing considered, collaborative step-wise approach to any assignment.
        The pair recognizes and praises each others work, which each fondly appreciates.`,
     },
    //c and c
    {
        head:`Moderately compatible`,
        body:`These two cool, calm, and collected individuals together will be aware and sensitive to each other's needs. The two have a passion for excellence that outsiders will recognize.
        Together, these two tend to put quality and thoroughness into their work and no matter how complex the assignment, they will be realistic about the solutions presented while offering detail-oriented efficiency.`,
    },
    //s and i
    {
        head:`Most naturally compatible`,
        body:`'S' type practically gets along with everybody in a task situation and the I’s enthusiasm makes this an eager and animated pair.
        They will exert a calming, stabilizing influence which will mutually inspire each other since they both are naturally interested in making a valuable contribution – resulting in the pair marching happily towards the finish line`,
    },
    //c and i
    {
        head:`Least compatible`,
        body:`C and I pairings are actually quite opposite in their thinking, although they both can be mutually influenced by something that stimulates their interest. ‘Conscientious’ styles are sensitive to others'
        needs and have a passion for excellence that others, especially the ‘Influential’ counterpart, will usually recognize. 'C' tend to put quality and thoroughness into their work while I’s may float around with a helping hand if C’s can boost their ego and/or engage in conversation every now and then`,
    },
    //c and s
    {
        head:`Most naturally compatible`,
        body:`Both on a mission of diligence and reliability to follow-through. It may get quiet at times, but since the ‘S’ types’ practically gets along with everybody in a task situation and are supportive workers, the compliant ‘C’ types will admire the unbothered setting and work methodically work towards their goal.
        Both naturally interested in others and in making a contribution, they will enjoy being
        productive partners on a task`,
    },
     //d and c
     {
        head:`Least compatible`,
        body:`As for this pairing, there is only a
        slight clash in the Dominant style's need to be vocal, with intense speed and
        control over the 'C' style's desire for a slower,
        systematic pace without any surprises or interruptions.`,
    },
    //d and i
    {
        head:`Most naturally compatible`,
        body:`These two together have moderately high social rapport but can plummet down to the lowest levels of
        compatibility when complex tasks are involved because they both tend
        to want to delegate the nitty gritty. When together, consider refraining from drama and not being overly pushy`,
    },
    //d and s
    {
        head:`Most naturally compatible`,
        body:`If the reliable 'S' type are open to following the sometimes-pushy commands from the ‘D’ type's vision, the Steady type will follow along in a calming influence (due to their natural interest in others and in making a contribution). D types’s fireball of ambition may just be what the Steady ‘S’ needs to push on through and see the finish line, but don't over do it with assertion.`,
    },

]

export {taskCompatibility}
